module.exports = __webpack_public_path__ + "media/images/icons/type-accommodatie-8a8c2a501cd59bd1a78180dfcf19eb07.svg";